import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';
import { Store } from '@ngrx/store';

import { Observable, Subscriber } from 'rxjs';
import { first } from 'rxjs/operators';

import { setUser } from '../../state/user/user.actions';
import { IUser } from '../../state/user/user.models';
import { selectUser } from '../../state/user/user.selectors';
import { PersonaService } from '../http/apiPersona/persona.service';
import { LoggingService } from '../services/logging/logging.service';
import { MsalAccountService } from '../services/msal-account/msal-account.service';
import { MatDialog } from '@angular/material/dialog';
import { ErrorBlockingDialogComponent } from 'src/app/shared/components/error-blocking-dialog/error-blocking-dialog.component';

@Injectable({providedIn: 'root'})
export class PreLoadGuard implements CanActivateChild {

  constructor(
    private dialog: MatDialog,
    private personaService: PersonaService,
    private authService: MsalService,
    private store: Store,
    private logger: LoggingService,
    private _msalAccountService: MsalAccountService
  ) {
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return new Observable(subscribe => {

      // Intentamos obtener la info del store. 
      // Si existe, omitimos todo el resto de pasos para evitar llamadas innecesarias
      this.store.select(selectUser).pipe(first()).subscribe(user => {
        // Si hay partner, ni me molesto en seguir. Ya se que está cargado
        if(!!user.partner) {
          /// Resolución de la susbcribe del guard
          this.resolveSubscribe(subscribe, true);
        } else {
          
          // Como no hay partner, toca ir a buscarlo.
          // Obtenemos la info guardada de la cuenta de msal para poder atacara los endpoints con la info
          const account = this._msalAccountService.getAccountInfo();
          if (!!account) {
            const userData = account as IUser;
            userData.idEntidadesAsociadas = [];

            // Obtenemos el token para poder atacar al APIM. Este token ES DIFERENTE al del account.idToken !!!!
            this.getAcquireSilentTokenPromise(account).then((authenticationResult:any) => {

                // ToDo: Guardar el token en el store en vez del sessionStorage
                this.logger.logTrace("Preloadguard pre storedispatch: idtoken ", [authenticationResult.idToken]);

                this.getPersonAndPartnerByTokenOIDAsObservable(authenticationResult.idTokenClaims.oid).subscribe(res => {
                  // En caso de que el cliente no tenga asociado ninguna entidad se muestra una pantalla de bloqueo
                  if(res === null || res?.data?.length === 0){
                    this.openErrorDialog();
                  }

                  // En caso de que haya entidades asociadas continuamos
                  if (res?.data?.length > 0) {
                    const dataByOID = res.data

                    // Guardar todas las entidades asociadas para poder mostrar el combo en la calculadora cuando lo pidan,
                    // el combo de calculadora necesitará obtener todos los datos de cada una de las entidades que tengamos en este array
                    dataByOID.forEach(element => {
                      userData.idEntidadesAsociadas.push(element.idEntidad)
                    });
                   
                    // Obtenemos los datos de la primera entidad recibida para tener una seleccionada por defecto
                    this.getPartnerInfoObservable(res.data[0].idEntidad).subscribe(partner_info_response => {
                      
                      // Validación
                      if (partner_info_response.succeeded && !!partner_info_response.data) {
                        
                        // Asignación de userData y guardado en el store. 
                        // Esto prevendrá futuros retrabajos cuando pase por este Guard
                        userData.partner = partner_info_response.data;
                        userData.partner.idEntidad = res.data[0].idEntidad;
                        this.store.dispatch(setUser({ accountInfo: userData }));

                        // Resolución de la susbcribe del guard
                        this.resolveSubscribe(subscribe, true);
                      } else {
                        /// Resolución de la susbcribe del guard
                        this.resolveSubscribe(subscribe, false);
                      }
                    })
                  } else {
                    /// Resolución de la susbcribe del guard
                    this.resolveSubscribe(subscribe, false);
                  }
                })
            })
          } else {
            /// Resolución de la susbcribe del guard
            this.resolveSubscribe(subscribe, false);
          }
        }
      })
    })
  }

  openErrorDialog() {
    const dialogRef = this.dialog.open(ErrorBlockingDialogComponent, {
      height: '100vh',
      minWidth: '100vw',
    });

    dialogRef.afterClosed().subscribe((res) => {
      this.dialog.closeAll();
    });
  }

  getPersonAndPartnerByTokenOIDAsObservable(OID: string) {
    return this.personaService.getPersonAndPartnerByTokenOID(OID);
  }

  getPartnerInfoObservable(idEntidad: number) {
    return this.personaService.getPartnerInfo(idEntidad).pipe(first());
  }

  getEntidadByEmailObservable(userData: IUser) {
    return this.personaService.getEntidadByEmail(this.strToHex(userData.username)).pipe(first());
  }

  getAcquireSilentTokenPromise(userData: AccountInfo) {
    const accessTokenRequest = {
      scopes: ["user.read"],
      account: userData as AccountInfo
    }
    return this.authService.instance.acquireTokenSilent(accessTokenRequest);
  }

  resolveSubscribe(subscribe: Subscriber<boolean | UrlTree>, result: boolean){
    subscribe.next(result);
    subscribe.complete();
  }

  strToHex(str: string): string {
    var result = "";
    for (var i = 0; i < str.length; i++) {
      result += str.charCodeAt(i).toString(16);
    }
    return result;
  }
}
